export default __webpack_public_path__ + "static/times-up-b5986b6775a2b322fb2fbd267d6409ef.mp3";